module.exports = __webpack_public_path__ + "static/media/avatar_dog.f8b45b81.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_dog.png
// module id = 375
// module chunks = 0